import { h } from '@stencil/core';
import { TAGS_IMPORTANCE_BY_TYPE, TAGS_STATUS_BY_TYPE, QdsSize, getIconProps, } from '@pes-ui/utils';
export const PesTag = ({ id, value, size, }) => {
  const iconProps = getIconProps(id);
  return (h("qds-tag", Object.assign({}, iconProps, { text: value === null || value === void 0 ? void 0 : value.label, importance: TAGS_IMPORTANCE_BY_TYPE[id], status: TAGS_STATUS_BY_TYPE[id], size: size !== null && size !== void 0 ? size : QdsSize.SMALL, class: "tag" })));
};
